import React, { useContext } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import ThemeContext from "../utils/Contexts/ThemeContext";

function PlacementFilterModal({
  allPlacements,
  placements,
  activePlacementTab,
  isLoading,
  links,
  allLinks,
  activeLinkTab,
  allRels,
  rels,
  activeRelTab,
  niches,
  allNiches,
  activeNicheTab,
  setActivePlacementTab,
  setActiveRelTab,
  setActiveLinkTab,
  setActiveNicheTab,
  setFormData,
  updatePendingFilter,
  pendingFilters,
}) {
  const { t } = useContext(LanguageContext);
  const { selectedTheme } = useContext(ThemeContext);

  const applyFilters = () => {
    setFormData((prevData) => {
      const updatedFilters = [...prevData.search.filters];

      pendingFilters.forEach((filter) => {
        if (filter.key !== "UUID") {
          const filterIndex = updatedFilters.findIndex(
            (f) => f.key === filter.key
          );

          if (filterIndex !== -1) {
            updatedFilters[filterIndex] = {
              key: filter.key,
              value: filter.value,
            };
          } else {
            updatedFilters.push({ key: filter.key, value: filter.value });
          }
        }
      });

      return {
        ...prevData,
        length: 15,
        search: {
          ...prevData.search,
          filters: updatedFilters,
        },
      };
    });
    const modalElement = document.getElementById("offcanvasPlacementFilter");
    if (modalElement) {
      modalElement.classList.remove("show"); // Removes the 'show' class to hide the modal
    }
    const backdropElement = document.querySelector(".offcanvas-backdrop");
    if (backdropElement) {
      backdropElement.classList.remove("show"); // Remove the backdrop if present
    }
  };

  const handlePlacementTabClick = (placementValue) => {
    setActivePlacementTab(placementValue);
    updatePendingFilter("TYPE", placementValue);
  };

  const handleRelTabClick = (relValue) => {
    setActiveRelTab(relValue);
    updatePendingFilter("REL", relValue);
  };

  const handleLinkClick = (linkValue) => {
    setActiveLinkTab(linkValue);
    updatePendingFilter("LINKS", linkValue);
  };

  const handleNicheClick = (nicheValue) => {
    setActiveNicheTab(nicheValue);
    updatePendingFilter("NICHE", nicheValue);
  };

  const handleClearFilters = () => {
    setFormData((prevData) => {
      return {
        ...prevData,
        search: {
          ...prevData.search,
          filters: prevData.search.filters.map((filter) =>
            ["TYPE", "REL", "LINKS", "NICHE"].includes(filter.key)
              ? { ...filter, value: 1 } // Reset specific filters to "1"
              : filter
          ),
        },
      };
    });
    setActivePlacementTab(1);
    setActiveRelTab(1);
    setActiveLinkTab(1);
    setActiveNicheTab(1);
  };

  return (
    <div
      className="offcanvas offcanvas-end rounded-4"
      tabIndex="-1"
      id="offcanvasPlacementFilter"
      aria-labelledby="offcanvasPlacementFilterLabel"
      aria-hidden="true"
      style={{
        top: "21px",
        right: "0",
        bottom: "21px",
        marginRight: "12px",
        width: "calc(100% - 20px)",
        border:
          selectedTheme === "dark"
            ? "2px solid rgba(45, 50, 54, 1)"
            : "1px solid rgb(172, 172, 172)",
      }}
    >
      <div
        className="offcanvas-header px-3 pb-3"
        style={{
          borderBottom:
            selectedTheme === "dark"
              ? "2px solid rgba(45, 50, 54, 1)"
              : "1px solid rgb(172, 172, 172)",
        }}
      >
        <h3 id="offcanvasPlacementFilterLabel" className="mb-0 pb-0">
          {t("Filters")}
        </h3>
      </div>
      <div className="offcanvas-body px-3 pt-3">
        <div className="row d-md-none d-block">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Placement")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-md-none d-block">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                  role="tablist"
                >
                  {allPlacements.map((placement) => {
                    const isAvailable = placements.some(
                      (p) => p.type === placement.value
                    );
                    return (
                      <li className="nav-item col-4" key={placement.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activePlacementTab === placement.value
                              ? "active"
                              : ""
                          } ${!isAvailable || isLoading ? "disabled" : ""}`}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activePlacementTab === placement.value}
                          onClick={(e) => {
                            if (!isAvailable || isLoading) {
                              e.preventDefault();
                              return;
                            }
                            handlePlacementTabClick(placement.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                          style={{ borderRadius: '.4rem' }}
                        >
                          {placement?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-md-none d-block">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Links")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-md-none d-block">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {allLinks.map((link) => {
                    const isAvailable = links?.includes(link.value);
                    return (
                      <li className="nav-item col-4" key={link.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeLinkTab === link.value ? "active" : ""
                          } ${!isAvailable || isLoading ? "disabled" : ""}`}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeLinkTab === link.value}
                          onClick={(e) => {
                            if (!isAvailable || isLoading) {
                              e.preventDefault();
                              return;
                            }
                            handleLinkClick(link.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {link?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xxl-none d-block">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Rel Type")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xxl-none d-block">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap flex-sm-nowrap col-12 justify-content-between"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {allRels.map((rel) => {
                    const isAvailable = rels?.includes(rel.value);
                    return (
                      <li className="nav-item col-4" key={rel.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeRelTab === rel.value ? "active" : ""
                          } ${!isAvailable || isLoading ? "disabled" : ""}`}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeRelTab === rel.value}
                          onClick={(e) => {
                            if (!isAvailable || isLoading) {
                              e.preventDefault();
                              return;
                            }
                            handleRelTabClick(rel.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {rel?.name}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="row d-xxl-none d-block">
          <div className="col-12">
            <span className="mb-2 text-secondary">{t("Niche")} </span>
          </div>
        </div>
        <div className="row mb-3 mt-2 d-xxl-none d-block">
          <div className="col-12">
            <div className="mb-2 js-nav-scroller hs-nav-scroller-horizontal col-12">
              <div className="col-12 text-center">
                <ul
                  className="nav nav-segment flex-wrap col-12"
                  role="tablist"
                  style={{
                    backgroundColor:
                      selectedTheme === "dark" ? "#1e2022" : "#f8fafd",
                    padding: "0.1rem",
                  }}
                >
                  {niches.map((nicheValue) => {
                    const matchingNiche = allNiches?.includes(nicheValue.value);
                    return (
                      <li className="nav-item col-4" key={nicheValue.value}>
                        <a
                          className={`js-loading-state-invoker nav-link ${
                            activeNicheTab === nicheValue.value ? "active" : ""
                          } ${!matchingNiche || isLoading ? "disabled" : ""}`}
                          id="nav-one-eg1-tab"
                          data-bs-toggle="pill"
                          href="#nav-one-eg1"
                          role="tab"
                          aria-controls="nav-one-eg1"
                          aria-selected={activeNicheTab === nicheValue.value}
                          onClick={(e) => {
                            if (!matchingNiche || isLoading) {
                              e.preventDefault();
                              return;
                            }
                            handleNicheClick(nicheValue.value);
                          }}
                          data-hs-loading-state-options='{
                            "targetEl": "#nav-one-eg1",
                            "removeLoaderDelay": "300"
                          }'
                        >
                          {nicheValue?.content}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="offcanvas-footer px-4 py-3">
        <div className="row gx-3">
          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-outline-primary py-2"
                onClick={handleClearFilters}
              >
                {t("Reset Filters")}
              </button>
            </div>
          </div>

          <div className="col">
            <div className="d-grid">
              <button
                type="button"
                className="btn btn-primary py-2"
                onClick={applyFilters}
              >
                {t("Apply")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlacementFilterModal;
